import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ADMIN_USER_GROUPS_READ, ADMIN_USER_GROUPS_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';
import FlexBox from 'components/common/FlexBox';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const UserGroupListComponent = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const canWrite = usePermission(ADMIN_USER_GROUPS_WRITE);
  const canRead = usePermission(ADMIN_USER_GROUPS_READ);

  const navigateToUserGroup = useCallback(() => {
    historyContext.push(`/userGroups/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell size='small'>
        <Typography title={data.code}>{data.code}</Typography>
      </TableCell>
      <TableCell size='small'>
        <Typography title={data.name}>{data.name}</Typography>
      </TableCell>
      <TableCell align='right'>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='edit'
            tooltip={t('Edit')}
            onClick={navigateToUserGroup}
            disabled={!canRead}
          />
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            disabled={!canWrite}
            onClick={() => onDelete(data.id)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

UserGroupListComponent.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func.isRequired
};

export default UserGroupListComponent;
